import createModel from 'utils/model'
import _ from 'lodash'
import {detailStatByDate, detailStatByHour} from 'crm/services/drainage-channel-stat'
import dayjs from 'dayjs'
import constants from 'crm/common/constants'

const {dateFormat} = constants

function getInitTableParamsState() {
    return {
        date_from: `${dayjs().subtract(6, 'days').format(dateFormat)}`,
        date_to: `${dayjs().format(dateFormat)}`,
        action_type: undefined,
    }
}

function getInitTableState() {
    return {
        params: getInitTableParamsState(),
        searchParams: {},
        tableData: [],
        chartData: [],
    }
}

function getFilledData(data, from, to) {
    const addition = []
    let startTime = dayjs(from)
    const endTime = dayjs(to)
    const diff = endTime.diff(startTime, 'days') + 1
    if (data.length === diff) {
        return data
    }
    for (let i = 1; i <= diff; i++) {
        const year = startTime.year()
        let month = startTime.month() + 1
        let day = startTime.date()
        month = month < 10 ? `0${month}` : month
        day = day < 10 ? `0${day}` : day
        addition.push({
            st_date: `${year}-${month}-${day}`,
        })
        startTime = startTime.add(1, 'day')
    }

    return addition
        .map((item) => {
            const temp = data.find((v) => v.st_date === item.st_date)
            if (temp) {
                return {
                    ...item,
                    ...temp,
                }
            }
            return item
        })
        .reverse()
}

export default createModel({
    namespace: 'crm_drainage_channelStat_details',

    state: {
        ...getInitTableState(),
    },

    effects: {
        *getDetailData({payload}, {select, call, put}) {
            const {params} = yield select(
                ({crm_drainage_channelStat_details}) => crm_drainage_channelStat_details,
            )
            const query = _.cloneDeep({...params, ...payload})
            let data = null

            const byHour = query?.date_from && query?.date_from === query?.date_to

            // 起始日期一样，请求分时段的统计接口
            if (byHour) {
                query.channel_id = payload?.state
                query.time_from = `${query?.date_from} 00:00:00`
                query.time_to = `${query?.date_to} 23:59:59`
                delete query.date_from
                delete query.date_to
                delete query.state

                const res = yield call(detailStatByHour, query)
                data = res?.data || []
                data.forEach((item, index) => {
                    item.id = index + 1
                })

                // 将hour的字段值添加成与日期的字段一样
                if (data?.length) {
                    data.forEach((item) => {
                        item.st_date = `${item.hour}时`
                    })
                }
            } else {
                const res = yield call(detailStatByDate, query)
                data = res?.data || []

                if (query.date_from && query.date_to) {
                    data = getFilledData(data, query.date_from, query.date_to)
                }

                data.forEach((item, index) => {
                    item.id = index + 1
                })
            }

            const cloneData = _.clone(data)
            yield put({
                type: 'setProperty',
                payload: {
                    tableData: byHour ? cloneData.reverse() : data,
                    chartData: byHour ? data : cloneData.reverse(),
                    searchParams: params,
                },
            })
        },
    },

    reducers: {
        resetTableParams(state) {
            return {...state, params: getInitTableParamsState()}
        },
        resetTable(state) {
            return {...state, ...getInitTableState()}
        },
        mergeTableParams(state, action) {
            return {...state, params: {...state.params, ...action.payload}}
        },
    },
})
